module.exports = __webpack_public_path__ + "createstatic/media/bannerlogo.961307b7.png";